import { Observable } from "rxjs";

export interface CurpData {
  [k: string]: any;
}

export const CurpCallbacks = {
  CACHE: "CACHE",
  API_USERS: "API_USERS",
  NUBARIUM: "NUBARIUM",
  SCRAPING: "SCRAPING",
} as const;
export type CurpCallbackKey = typeof CurpCallbacks[keyof typeof CurpCallbacks];

/** Each provider returns CurpData or null (null = not found) and must NOT throw (map errors to null) */
export type CurpProvider = (curp: string) => Observable<CurpData | null>;
